




import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'UCRichTextDisplay',
  props: {
    richText: {
      type: String,
      required: true,
    },
  },
});
